import ClientLike from "../client-like";
import PurchaseRepository from "@/usecases/accounting/purchase-repository";
import Purchase from "@/usecases/accounting/purchase";
import purchaseStatusTranslater from "@/usecases/accounting/purchase-status-translater";

export default class PurchaseApi implements PurchaseRepository {
  public constructor(private client: ClientLike) {}

  public async find(id: number): Promise<Purchase | undefined> {
    const res = await this.client.get("get_purchase.php", { id });
    if (res.purchases.length > 0) {
      return toPurchase(res.purchases[0]);
    }
  }

  public async findAll(options?: {
    projectId?: string;
    projectName?: string;
  }): Promise<Purchase[]> {
    const res = await this.client.get("get_purchase.php", options);
    return res.purchases.map(toPurchase);
  }

  public async save(purchase: Purchase): Promise<number> {
    const data = await this.client.post("save_purchase.php", purchase);
    return data.id;
  }

  public async destroy(id: number): Promise<void> {
    const d = new FormData();
    d.append("id", String(id));
    await this.client.post("delete_purchase.php", d);
  }
}

function toPurchase(data: any): Purchase {
  return {
    ...data,
    statusName: purchaseStatusTranslater.toJp(data.status)
  };
}
